import React from 'react';
import { Badge } from '@/components/ui/badge';
import { BookOpen, Grid3X3 } from 'lucide-react';
import { useUnifiedCourseCounts } from '@/hooks/useUnifiedCourseCounts';

interface CourseCountBadgeProps {
  variant?: 'default' | 'secondary' | 'outline';
  size?: 'sm' | 'default' | 'lg';
  showIcons?: boolean;
  className?: string;
}

export const CourseCountBadge: React.FC<CourseCountBadgeProps> = ({
  variant = 'secondary',
  size = 'default',
  showIcons = true,
  className = ''
}) => {
  const { totalCourses, totalCategories, loading } = useUnifiedCourseCounts();

  if (loading) {
    return (
      <Badge variant={variant} className={className}>
        Loading...
      </Badge>
    );
  }

  return (
    <Badge variant={variant} className={`flex items-center gap-2 ${className}`}>
      {showIcons && <Grid3X3 className="h-3 w-3" />}
      <span>{totalCategories}+ Categories</span>
      <span>•</span>
      {showIcons && <BookOpen className="h-3 w-3" />}
      <span>{totalCourses}+ Courses</span>
    </Badge>
  );
};

export default CourseCountBadge;